import "core-js/modules/es6.number.constructor.js";
import '@web/shared-digital-library/icons/svg-originals/bx-chevron-right.svg';
var MdmLink = function MdmLink() {
  return import('~/components/atoms/MdmLink.vue');
};
var CardHorizontal = function CardHorizontal() {
  return import('~/components/molecules/CardHorizontal.vue');
};
export default {
  name: 'NavItemLeaf',
  components: {
    MdmLink: MdmLink,
    CardHorizontal: CardHorizontal
  },
  props: {
    level: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    withColor: {
      type: Boolean,
      default: false
    },
    withArrow: {
      type: Boolean,
      default: false
    },
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  }
};